import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";

export function useSectionCommitteeManagementGate() {
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();

  return {
    flagsLoaded,
    enabled: flags["backoffice-section-committee-management"] === true
  };
}

export function useSectionCommitteeManagementEnabled() {
  return useSectionCommitteeManagementGate().enabled;
}
